import script from "./PopupMenuItem.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupMenuItem.vue?vue&type=script&setup=true&lang=js"

import "./PopupMenuItem.vue?vue&type=style&index=0&id=723b6922&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-723b6922"]])

export default __exports__